import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import styles from '../../MenuItem.module.scss';
import { UserTypes } from '../../../../domains/user/user-types';

import { ReactComponent as DashboardIcon } from '../../../../assets/icons/icon_dashboard-menu.svg';

const DashboardButton = ({ handleMenuLinkClick, user }) => {
  if (user?.user_type !== UserTypes.tutor) return;

  return (
    <li className={styles['link-wrapper']} data-testid="dashboard-button">
      <NavLink
        to="/dashboard"
        onClick={() => handleMenuLinkClick('dashboard')}
        activeClassName={styles.isActive}
        className={styles.menuItem}
        data-testid="dashboard-link">
        <div className={styles['button-wrapper']}>
          <div className={styles['background']}>
            <DashboardIcon />
          </div>
          <span>Dashboard</span>
        </div>
      </NavLink>
    </li>
  );
};

DashboardButton.propTypes = {
  handleMenuLinkClick: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
};

export default DashboardButton;
